import React from 'react';
import cx from 'classnames';

import ArrowUp from '../Icons/ArrowUp';
import Information from '../Icons/Information';
import Note from '../Note';
import Text from '../Text';
import Tooltip from '../Tooltip';

import styles from './SingleValue.module.scss';

export interface Props {
  /** Override SingleValue styles by adding a className */
  className?: Parameters<typeof cx>[0];
  /** Text shown in the tooltip when hovering over the info icon. Info icon does not show
   *  unless this value is present. */
  infoText?: string;
  /** Text shown below the value */
  subtitle?: string;
  /** Value shown above the value */
  title: string;
  /** Optional value that when present, will appear in a trending section in the bottom right */
  trendingValue?: number;
  /** Value shown in the center of the component */
  value: number;
}

export const SingleValue: React.FC<Props> = ({
  className,
  infoText,
  subtitle,
  title,
  trendingValue,
  value,
}) => (
  <div className={cx(styles.singleValue, className)}>
    <div className={cx(styles.title, infoText && styles.info)}>
      <Text contrast='low' size={12} weight='medium' as='span'>
        {title}
      </Text>
      {infoText ? (
        <Tooltip
          dark
          placement='top'
          showOn='hover'
          small
          target={<Information className={styles.infoIcon} />}
          wrapperClassName={styles.infoTooltip}
          triggerWrapperClassName={styles.infoTooltipTriggerWrapper}
        >
          {infoText}
        </Tooltip>
      ) : null}
    </div>
    <Text size={24} weight='semiBold' as='span' className={styles.value}>
      {value.toLocaleString('en-US')}
    </Text>

    {subtitle ? (
      <div
        className={cx(
          styles.subtitleContainer,
          trendingValue != null && styles.noteContainer,
        )}
      >
        <Text contrast='low' size={12} weight='medium' as='span'>
          {subtitle}
        </Text>
        {trendingValue != null ? (
          <div>
            <Note className={styles.note} success solid>
              <ArrowUp className={styles.noteIcon} />
              {trendingValue.toLocaleString('en-US')}
            </Note>
          </div>
        ) : null}
      </div>
    ) : null}
  </div>
);

SingleValue.displayName = 'SingleValue';
export default SingleValue;
export { styles };
